/* tslint:disable */

/**
 */
export class Users {
    TRACE_LEVEL?: number;
    ID_USER?: number;
    CODE_LANGUE?: number;
    ID_CALC_PARAMSDEF?: number;
    ID_TEMP_RECORD_PTS_DEF?: number;
    USERNAM?: string;
    USERPRIO?: number;
    ID_MONETARY_CURRENCY?: number;
    USER_ENERGY?: number;
    USER_CONSTRUCTOR?: string;
    USER_FAMILY?: number;
    USER_ORIGINE?: number;
    USER_PROCESS?: number;
    USER_MODEL?: number;
    USERMAIL?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/users.ts